import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { OpeningService } from 'src/app/api/money/opening.service';
import { ComunicationNavtopBranchofficeService } from 'src/app/utils/comunication-navtop-branchoffice.service';
import * as _ from 'underscore';
declare var $: any;

@Component({
  selector: 'app-navtop-branchoffice-information',
  templateUrl: './navtop-branchoffice-information.component.html',
  styleUrls: ['./navtop-branchoffice-information.component.css']
})
export class NavtopBranchofficeInformationComponent implements OnInit {
  branchofficeSlug: string = '';
  // variables
  check_moneybox: boolean = false;
  boxselected: any = null;
  moneybox: any = null;
  validatealert: boolean = false;

  constructor(
    private openingService: OpeningService,
    private globalService: GlobalService,
    private ComunicationNavtopBranchofficeService: ComunicationNavtopBranchofficeService
  ) {

    this.ComunicationNavtopBranchofficeService.data$.subscribe(data => {
      this.check_moneybox = false;
      this.boxselected = null;
      this.moneybox = null;
      this.validatealert = true;
      this.checkBoxSelected();
    });
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.checkBoxSelected();
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {
        if (!_.isNull(data.data)) {
          this.boxselected = data.data;
          this.getBoxOpening();
        }
      }
    });
  }

  getBoxOpening() {
    this.openingService.getBoxOpening(this.boxselected.id).subscribe({
      next: (data: any) => {
        this.validatealert = true;
        if (data.data) {
          this.check_moneybox = true;
          this.moneybox = data.data;
        }
      }
    });
  }
}
